import { array, node } from 'prop-types'
import { Box, Divider, Spacer, StackView, Typography } from '@telus-uds/components-web'
import { isEmpty, isNil } from 'ramda'
import useTranslate from '../../../../hooks/useTranslate'

const OtherChargesAndCreditsContainer = ({ children, listData }) => {
  const translate = useTranslate()

  const noDataToDisplay = isEmpty(listData) || isNil(listData)

  if (noDataToDisplay) return null

  return (
    <Box left={{ xs: 0, md: 3 }}>
      <StackView testID="other-charges-container">
        <Spacer space={2} />
        <Typography variant={{ size: 'large' }} testID="breakdown-additional-charges-heading">
          {translate('additionalChargesAndCredits.heading')}
        </Typography>
        <Spacer space={2} />
        <Divider variant={{ decorative: true }} />
        <Spacer space={2} />
        {children}
      </StackView>
    </Box>
  )
}

export default OtherChargesAndCreditsContainer

OtherChargesAndCreditsContainer.propTypes = {
  children: node,
  listData: array
}

OtherChargesAndCreditsContainer.defaultProps = {
  children: null,
  listData: []
}
